import { styled } from '@mui/material/styles';
import React from 'react';
import { GivelifyBoxMarginProps } from '../GivelifyBaseProps';
import { GivelifyColorPalette } from '../style/givelifyDefaultTheme';

export interface GivelifyErrorBannerProps extends GivelifyBoxMarginProps {
    text: string | React.ReactChild[] | React.ReactChild;
    align?: 'center' | 'left' | 'right';
    className?: string;
}

type ErrorBannerRootProps = Omit<
    GivelifyErrorBannerProps,
    'text' | 'className'
>;

const ErrorBannerRoot = styled('div', {
    shouldForwardProp: (prop) =>
        ![
            'align',
            'margin',
            'marginLeft',
            'marginTop',
            'marginRight',
            'marginBottom',
        ].includes(prop as string),
})<ErrorBannerRootProps>(
    ({
        theme,
        align,
        margin,
        marginLeft,
        marginTop,
        marginRight,
        marginBottom,
    }) => ({
        fontFamily: theme.typography.fontFamily,
        color: GivelifyColorPalette.error300,
        borderRadius: 4,
        display: 'inline-block',
        marginLeft: marginLeft || margin,
        marginTop: marginTop || margin || theme.spacing(3),
        marginRight: marginRight || margin,
        marginBottom: marginBottom || margin,
        backgroundColor: GivelifyColorPalette.error100,
        paddingTop: 4,
        paddingBottom: 4,
        width: '100%',
        fontSize: 14,
        lineHeight: '24px',
        fontWeight: 600,
        textAlign: align ?? 'center',
    }),
);

export const GivelifyErrorBanner: React.FCC<GivelifyErrorBannerProps> = ({
    text,
    ...props
}) => (
    <ErrorBannerRoot {...props} data-testid="error-banner">
        {text}
    </ErrorBannerRoot>
);
